import { RadioGroup } from '@headlessui/react'
import { useFormContext, Controller } from 'react-hook-form'

import { FormSection } from '../../../components/ui/form/form-section'
import { PrioSmsInfoGraphic } from '../../../components/ui/form/prio-sms-info-graphic'

import type { UpdateBroadcastInputs } from '../broadcast.schema'

type Props = {
  disabled?: boolean
  onChange: (messageType: UpdateBroadcastInputs['messageType']) => void
}

function BroadcastMessageType({ disabled, onChange }: Props) {
  const { control, trigger } = useFormContext()

  return (
    <FormSection>
      <div className="flex flex-col gap-y-4 py-2">
        <div className="space-y-1">
          <p className="font-semibold">Send Via</p>
          <Controller
            name="messageType"
            control={control}
            render={({
              field: { value, onChange: onControllerChange, onBlur },
              fieldState,
            }) => (
              <RadioGroup
                className="border-ion-color-step-950 flex items-center gap-5"
                disabled={disabled}
                value={value}
                onBlur={onBlur}
                onChange={(e: any) => {
                  onControllerChange(e)
                  onChange(e)
                  fieldState.isTouched &&
                    trigger(['smsMessage', 'emailSubject', 'emailMessage'])
                }}
              >
                <RadioGroup.Option
                  value="sms"
                  className="flex cursor-pointer items-center rounded-full ui-disabled:cursor-default"
                >
                  <span className="border-ion-color-secondary ui-checked:bg-ion-color-yellow size-4 rounded-full border" />
                  <span className="flex cursor-pointer items-center px-1.5 leading-3 ui-disabled:cursor-default">
                    Text
                  </span>
                </RadioGroup.Option>
                <RadioGroup.Option
                  value="email"
                  className="flex cursor-pointer items-center rounded-full ui-disabled:cursor-default"
                >
                  <span className="border-ion-color-secondary ui-checked:bg-ion-color-yellow size-4 rounded-full border" />
                  <span className="flex cursor-pointer items-center px-1.5 leading-3 ui-disabled:cursor-default">
                    Email
                  </span>
                </RadioGroup.Option>
                <RadioGroup.Option
                  value="prioSmsEmail"
                  className="flex cursor-pointer items-center rounded-full ui-disabled:cursor-default"
                >
                  <span className="border-ion-color-secondary ui-checked:bg-ion-color-yellow size-4 rounded-full border" />
                  <span className="flex cursor-pointer items-center px-1.5 leading-3 ui-disabled:cursor-default">
                    Text or Email
                  </span>
                </RadioGroup.Option>
              </RadioGroup>
            )}
          />
        </div>
        <PrioSmsInfoGraphic />
      </div>
    </FormSection>
  )
}

export { BroadcastMessageType }
